import { render, staticRenderFns } from "./ImportSupplierPricesDialogWidget.vue?vue&type=template&id=0d44fdd4&"
import script from "./ImportSupplierPricesDialogWidget.vue?vue&type=script&lang=js&"
export * from "./ImportSupplierPricesDialogWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports